import ListTitle from "@/components/ListTitle";
import { School, Refresh, Upload } from "@mui/icons-material";
import { Box, IconButton, Stack, Tooltip } from "@mui/material";
import { Notification } from '@/components/Notification';
import { 
    TrainingSummary,
} from "@/components/training";
import { useTheme } from "@mui/material/styles";
import Search from "@/components/Search";
import { useContext, useState } from "react";
import { AppContext, TrainingsContext } from "@my-helpers/common";
import UploadTraining from "@/components/training/Upload";


const TrainingsView: React.FC = () => {
    const app = useContext(AppContext);
    const context = useContext(TrainingsContext);
    if (!app || !context) {
        throw new Error('TrainingsContext not found');
    }
    const { view, command } = context;
    const { isLoading, error, trainings } = view;
    const { 
        refreshTrainings, 
        clearError, 
        uploadTraining, 
        refreshTraining,
        removeTraining,
     } = command;
    const [uploading, setUploading] = useState<boolean>(false);
    const theme = useTheme();

    return (
        uploading ? 
        <UploadTraining 
            isLoading={isLoading}
            error={error}
            clearError={clearError}
            setUploading={setUploading}
            uploadTraining={uploadTraining}
        /> :
        <Stack padding={theme.spacing(3)}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                mb: 3
            }}>
                <ListTitle title="Trainings" icon={School} />
                <Search placeholder="Search trainings..." />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }} >
                    {  
                        app.view.sessionUser?.role === 'admin' &&
                        <Tooltip title="Load training">
                            <IconButton onClick={() => setUploading(true)}>
                                <Upload />
                            </IconButton>
                        </Tooltip>
                    }
                    <Tooltip title="Refresh trainings">
                        <IconButton color="primary" onClick={() => refreshTrainings()}>
                            <Refresh />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(12, 1fr)',
                gap: 2
            }}>
                {
                    trainings && trainings.map((training) =>
                        <Box
                            key={training.name}
                            sx={{
                                gridColumn: 'span 4',
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 2
                            }}>
                            <TrainingSummary
                                training={training}
                                refreshTraining={refreshTraining}
                                removeTraining={removeTraining}
                            />
                        </Box>
                    )
                }
            </Box>
            <Notification
                isLoading={isLoading}
                clearError={clearError}
                error={error}
                delay={300}
                autoHideDuration={1200}
            />
        </Stack>
    );
};

export default TrainingsView;